
export enum DiskType {

    DISK_NVME_M2_SSD = "DISK_NVME_M2_SSD",
    DISK_SSD = "DISK_SSD",
    DISK_HDD = "DISK_HDD"

}
